var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M27.611 15.384v-.5H12.318l6.48-6.48.354-.353-.354-.354-1.893-1.893-.354-.354-.353.354-10.56 10.56-.354.354.354.353 10.56 10.56.353.354.354-.354 1.893-1.893.354-.354-.354-.353-6.48-6.48h15.293v-3.167z"
  })));
};
export default SvgArrowBack;